.page {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.header {
  padding: 10px 20px;
  border-bottom: 2px solid var(--brand-color, #000);
  background: white;
}

.publicationHeader {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.publicationLogo {
  max-height: 50px;
  width: auto;
  max-width: 100%;
}

.main {
  padding: 0 20px;
}

.articleDate {
  font-size: 18px;
  font-weight: 500;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.articleIframe {
  width: 100%;
  height: calc(100vh - 135px);
  border: 0;
}

@media (max-width: 768px) {
  .articleDate {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 12px;
  }

  .main {
    padding: 12px;
  }

  .articleIframe {
    height: calc(100vh - 160px);
  }
}
